import { Flex, Icon, Span } from "@goodfill/ui-components";
import { PricedBond } from "../../../PricedBond";
import { BondFilter, BondFilterChipData, BondFilterData, BondFilterProps } from "../BondFilter";
import { BondFilterCriteria } from "../BondFilterCriteria";
import { BondFilterDataConstraints } from "../BondFilterDataConstraints";

export class BondFilterFavoriteIcon implements BondFilter {
  isVisibleInDropdown(): boolean {
    return false;
  }

  evaluate(data: BondFilterData, criteria: BondFilterCriteria): boolean {
    return !criteria.favorite || data.isFavorite;
  }

  updateConstraintByPricedBond(
    _pricedBond: PricedBond,
    current: BondFilterDataConstraints,
  ): BondFilterDataConstraints {
    return current;
  }

  getDefaultCriteriaConstraints(_pricedBond: PricedBond): Partial<BondFilterDataConstraints> {
    return {};
  }

  afterCriteriaCalculation(current: BondFilterDataConstraints): BondFilterDataConstraints {
    return current;
  }

  reset(criteria: BondFilterCriteria, defaultCriteria: BondFilterCriteria): BondFilterCriteria {
    return { ...criteria, favorite: defaultCriteria.favorite };
  }

  getChips(criteria: BondFilterCriteria, defaultCriteria: BondFilterCriteria): BondFilterChipData[] {
    return criteria.favorite
      ? [
          {
            id: "favorite",
            label: "Favorite",
            onClick: () => this.reset(criteria, defaultCriteria),
          },
        ]
      : [];
  }

  component(props: BondFilterProps) {
    const onToggle = () => {
      const newValue = !props.criteria.favorite;

      props.onChange({
        criteria: {
          ...props.criteria,
          favorite: newValue,
        },
      });
    };

    return (
      <Flex
        items="center"
        title={props.criteria.favorite ? "Show all bonds" : "Show only favorite bonds"}
        onClick={onToggle}
      >
        <Span primary={props.criteria.favorite} size="lg">
          <Icon name={props.criteria.favorite ? "star" : "star-empty"} />
        </Span>
      </Flex>
    );
  }

  applyCriteriaFromStorage(criteria: Partial<BondFilterCriteria>): Partial<BondFilterCriteria> {
    return criteria;
  }

  storeCriteriaToStorage(_criteria: BondFilterCriteria, _defaultCriteria: BondFilterCriteria): void {
    // favorite is intentionally not stored
  }
}
